import { createUseStyles } from 'react-jss';
import { Theme } from '@wds/styles';

type StyleProps = {
  isEnterpriseThankYou?: boolean;
};

type classNames = 'button' | 'enterpriseThankYouForm';

const useStyle = createUseStyles<classNames, StyleProps, Theme>(theme => ({
  button: {
    '& > a': {
      '&:hover, &:focus': {
        textDecoration: 'none',
      },
    },
  },
  /** Only applies to `enterpriseThankYou` */
  enterpriseThankYouForm: {
    // The wrench button used does not allow addition of a classname
    '& a': {
      backgroundColor: theme.palette.background.light,
      height: '50px',
      width: '140px',
      margin: [20, 'auto', 0],
      padding: 0,
      color: theme.palette.text.dark,
      border: [1, 'solid', theme.palette.text.dark],
      '&:hover, &:focus': {
        borderColor: theme.palette.border.main,
        backgroundColor: theme.palette.background.light,
      },
      '&:active': {
        borderColor: theme.palette.border.active,
        backgroundColor: theme.palette.background.light,
      },
    },
  },
}));

export default useStyle;
